import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\CompaniesSSOController::index
* @see app/Http/Controllers/CompaniesSSOController.php:27
* @route '/companies/{company}/sso'
*/
export const index = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/sso',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CompaniesSSOController::index
* @see app/Http/Controllers/CompaniesSSOController.php:27
* @route '/companies/{company}/sso'
*/
index.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return index.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesSSOController::index
* @see app/Http/Controllers/CompaniesSSOController.php:27
* @route '/companies/{company}/sso'
*/
index.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CompaniesSSOController::index
* @see app/Http/Controllers/CompaniesSSOController.php:27
* @route '/companies/{company}/sso'
*/
index.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CompaniesSSOController::enable
* @see app/Http/Controllers/CompaniesSSOController.php:48
* @route '/companies/{company}/enable'
*/
export const enable = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: enable.url(args, options),
    method: 'post',
})

enable.definition = {
    methods: ["post"],
    url: '/companies/{company}/enable',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CompaniesSSOController::enable
* @see app/Http/Controllers/CompaniesSSOController.php:48
* @route '/companies/{company}/enable'
*/
enable.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return enable.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesSSOController::enable
* @see app/Http/Controllers/CompaniesSSOController.php:48
* @route '/companies/{company}/enable'
*/
enable.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: enable.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CompaniesSSOController::toggleEnforce
* @see app/Http/Controllers/CompaniesSSOController.php:71
* @route '/companies/{company}/enforce-sso'
*/
export const toggleEnforce = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleEnforce.url(args, options),
    method: 'put',
})

toggleEnforce.definition = {
    methods: ["put"],
    url: '/companies/{company}/enforce-sso',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\CompaniesSSOController::toggleEnforce
* @see app/Http/Controllers/CompaniesSSOController.php:71
* @route '/companies/{company}/enforce-sso'
*/
toggleEnforce.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return toggleEnforce.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesSSOController::toggleEnforce
* @see app/Http/Controllers/CompaniesSSOController.php:71
* @route '/companies/{company}/enforce-sso'
*/
toggleEnforce.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleEnforce.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\CompaniesSSOController::disable
* @see app/Http/Controllers/CompaniesSSOController.php:85
* @route '/companies/{company}/sso'
*/
export const disable = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disable.url(args, options),
    method: 'delete',
})

disable.definition = {
    methods: ["delete"],
    url: '/companies/{company}/sso',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CompaniesSSOController::disable
* @see app/Http/Controllers/CompaniesSSOController.php:85
* @route '/companies/{company}/sso'
*/
disable.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return disable.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesSSOController::disable
* @see app/Http/Controllers/CompaniesSSOController.php:85
* @route '/companies/{company}/sso'
*/
disable.delete = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: disable.url(args, options),
    method: 'delete',
})

const sso = {
    index: Object.assign(index, index),
    enable: Object.assign(enable, enable),
    toggleEnforce: Object.assign(toggleEnforce, toggleEnforce),
    disable: Object.assign(disable, disable),
}

export default sso